<mat-card class="dialog-container">
  <div class="form-name-patient-info">
    <div>
      <div class="h5">
        {{ formTitle ?? '' }}
      </div>

      <!-- Patient details for patient overview page -->
      <app-patient-info-details
        [hideCurrentPlace]="data.hideCurrentPlace"
        [vcPatientDetails]="patientInfo"
      ></app-patient-info-details>
    </div>

    <div class="track-close-buttons">
      <button (click)="showHistory = !showHistory" mat-mini-fab>
        <mat-icon>history</mat-icon>
      </button>
      <button (click)="onClickOnCancel()" mat-mini-fab>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-card-content>
    <app-formio-renderer
      [(data)]="formioRendererData"
      [form]="form"
      [i18n]="i18n"
      (dataChange)="onFormDataChange()"
    ></app-formio-renderer>

    <!-- History -->
    <div *ngIf="showHistory" class="change-history-container">
      <div class="w-fit h6">
        {{ 'COMPONENT.DIALOG_PATIENT_OVERVIEW.changing_history' | translate }}
      </div>

      <ng-container *ngFor="let history of histories; let i = index; let last = last">
        <app-changing-history
          [data]="histories.slice(i, i + 2)"
          [form_file_name]="form_file_name"
          [hideFields]="data.hideHistoryFields"
          [i18n]="i18n"
          [index]="i"
          [last]="last"
          [showOldValues]="false"
        ></app-changing-history>
      </ng-container>
    </div>
  </mat-card-content>

  <mat-card-actions class="justify-end">
    <button (click)="onClickOnCancel()" mat-stroked-button>
      {{ i18n?.[renderOptions.language]?.['Abbrechen'] ?? 'Abbrechen' }}
    </button>
    <button (click)="onClickOnSave()" [disabled]="!hasFormChanged" mat-flat-button>
      {{ i18n?.[renderOptions.language]?.['Speichern'] ?? 'Speichern' }}
    </button>
  </mat-card-actions>
</mat-card>
